/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Document } from '../models';
// @ts-ignore
import type { InputDeleteRequestDocument } from '../models';
/**
 * ServiceRequestDocumentApi - axios parameter creator
 * @export
 */
export const ServiceRequestDocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  **Permission required**: [\"delete\", \"Document\"] 
         * @summary Delete request document | Permission required: [\"delete\", \"Document\"]
         * @param {InputDeleteRequestDocument} [inputDeleteRequestDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRequestDocument: async (inputDeleteRequestDocument?: InputDeleteRequestDocument, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/request-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputDeleteRequestDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Get a document from archive with matching queries | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} serviceRequestId 
         * @param {number} documentStructureId 
         * @param {number} [referrerPersonId] 
         * @param {number} [yearReference] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentForServiceId: async (serviceRequestId: number, documentStructureId: number, referrerPersonId?: number, yearReference?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceRequestId' is not null or undefined
            assertParamExists('getDocumentForServiceId', 'serviceRequestId', serviceRequestId)
            // verify required parameter 'documentStructureId' is not null or undefined
            assertParamExists('getDocumentForServiceId', 'documentStructureId', documentStructureId)
            const localVarPath = `/document/request-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (serviceRequestId !== undefined) {
                localVarQueryParameter['serviceRequestId'] = serviceRequestId;
            }

            if (documentStructureId !== undefined) {
                localVarQueryParameter['documentStructureId'] = documentStructureId;
            }

            if (referrerPersonId !== undefined) {
                localVarQueryParameter['referrerPersonId'] = referrerPersonId;
            }

            if (yearReference !== undefined) {
                localVarQueryParameter['yearReference'] = yearReference;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary upload a document for a service request
         * @param {number} [serviceRequestId] 
         * @param {number} [documentId] 
         * @param {number} [documentStructureId] 
         * @param {number} [referrerPersonId] 
         * @param {number} [yearReference] 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentForServiceRequest: async (serviceRequestId?: number, documentId?: number, documentStructureId?: number, referrerPersonId?: number, yearReference?: number, files?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/request-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (serviceRequestId !== undefined) { 
                localVarFormParams.append('serviceRequestId', serviceRequestId as any);
            }
    
            if (documentId !== undefined) { 
                localVarFormParams.append('documentId', documentId as any);
            }
    
            if (documentStructureId !== undefined) { 
                localVarFormParams.append('documentStructureId', documentStructureId as any);
            }
    
            if (referrerPersonId !== undefined) { 
                localVarFormParams.append('referrerPersonId', referrerPersonId as any);
            }
    
            if (yearReference !== undefined) { 
                localVarFormParams.append('yearReference', yearReference as any);
            }
                if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceRequestDocumentApi - functional programming interface
 * @export
 */
export const ServiceRequestDocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceRequestDocumentApiAxiosParamCreator(configuration)
    return {
        /**
         *  **Permission required**: [\"delete\", \"Document\"] 
         * @summary Delete request document | Permission required: [\"delete\", \"Document\"]
         * @param {InputDeleteRequestDocument} [inputDeleteRequestDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRequestDocument(inputDeleteRequestDocument?: InputDeleteRequestDocument, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRequestDocument(inputDeleteRequestDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceRequestDocumentApi.deleteRequestDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Get a document from archive with matching queries | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} serviceRequestId 
         * @param {number} documentStructureId 
         * @param {number} [referrerPersonId] 
         * @param {number} [yearReference] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentForServiceId(serviceRequestId: number, documentStructureId: number, referrerPersonId?: number, yearReference?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentForServiceId(serviceRequestId, documentStructureId, referrerPersonId, yearReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceRequestDocumentApi.getDocumentForServiceId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary upload a document for a service request
         * @param {number} [serviceRequestId] 
         * @param {number} [documentId] 
         * @param {number} [documentStructureId] 
         * @param {number} [referrerPersonId] 
         * @param {number} [yearReference] 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDocumentForServiceRequest(serviceRequestId?: number, documentId?: number, documentStructureId?: number, referrerPersonId?: number, yearReference?: number, files?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDocumentForServiceRequest(serviceRequestId, documentId, documentStructureId, referrerPersonId, yearReference, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceRequestDocumentApi.uploadDocumentForServiceRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceRequestDocumentApi - factory interface
 * @export
 */
export const ServiceRequestDocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceRequestDocumentApiFp(configuration)
    return {
        /**
         *  **Permission required**: [\"delete\", \"Document\"] 
         * @summary Delete request document | Permission required: [\"delete\", \"Document\"]
         * @param {InputDeleteRequestDocument} [inputDeleteRequestDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRequestDocument(inputDeleteRequestDocument?: InputDeleteRequestDocument, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.deleteRequestDocument(inputDeleteRequestDocument, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Get a document from archive with matching queries | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} serviceRequestId 
         * @param {number} documentStructureId 
         * @param {number} [referrerPersonId] 
         * @param {number} [yearReference] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentForServiceId(serviceRequestId: number, documentStructureId: number, referrerPersonId?: number, yearReference?: number, options?: RawAxiosRequestConfig): AxiosPromise<Document> {
            return localVarFp.getDocumentForServiceId(serviceRequestId, documentStructureId, referrerPersonId, yearReference, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary upload a document for a service request
         * @param {number} [serviceRequestId] 
         * @param {number} [documentId] 
         * @param {number} [documentStructureId] 
         * @param {number} [referrerPersonId] 
         * @param {number} [yearReference] 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentForServiceRequest(serviceRequestId?: number, documentId?: number, documentStructureId?: number, referrerPersonId?: number, yearReference?: number, files?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.uploadDocumentForServiceRequest(serviceRequestId, documentId, documentStructureId, referrerPersonId, yearReference, files, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceRequestDocumentApi - interface
 * @export
 * @interface ServiceRequestDocumentApi
 */
export interface ServiceRequestDocumentApiInterface {
    /**
     *  **Permission required**: [\"delete\", \"Document\"] 
     * @summary Delete request document | Permission required: [\"delete\", \"Document\"]
     * @param {InputDeleteRequestDocument} [inputDeleteRequestDocument] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestDocumentApiInterface
     */
    deleteRequestDocument(inputDeleteRequestDocument?: InputDeleteRequestDocument, options?: RawAxiosRequestConfig): AxiosPromise<boolean>;

    /**
     *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
     * @summary Get a document from archive with matching queries | Permission required: [\"readOne\", \"ServiceRequest\"]
     * @param {number} serviceRequestId 
     * @param {number} documentStructureId 
     * @param {number} [referrerPersonId] 
     * @param {number} [yearReference] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestDocumentApiInterface
     */
    getDocumentForServiceId(serviceRequestId: number, documentStructureId: number, referrerPersonId?: number, yearReference?: number, options?: RawAxiosRequestConfig): AxiosPromise<Document>;

    /**
     * 
     * @summary upload a document for a service request
     * @param {number} [serviceRequestId] 
     * @param {number} [documentId] 
     * @param {number} [documentStructureId] 
     * @param {number} [referrerPersonId] 
     * @param {number} [yearReference] 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestDocumentApiInterface
     */
    uploadDocumentForServiceRequest(serviceRequestId?: number, documentId?: number, documentStructureId?: number, referrerPersonId?: number, yearReference?: number, files?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<object>;

}

/**
 * ServiceRequestDocumentApi - object-oriented interface
 * @export
 * @class ServiceRequestDocumentApi
 * @extends {BaseAPI}
 */
export class ServiceRequestDocumentApi extends BaseAPI implements ServiceRequestDocumentApiInterface {
    /**
     *  **Permission required**: [\"delete\", \"Document\"] 
     * @summary Delete request document | Permission required: [\"delete\", \"Document\"]
     * @param {InputDeleteRequestDocument} [inputDeleteRequestDocument] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestDocumentApi
     */
    public deleteRequestDocument(inputDeleteRequestDocument?: InputDeleteRequestDocument, options?: RawAxiosRequestConfig) {
        return ServiceRequestDocumentApiFp(this.configuration).deleteRequestDocument(inputDeleteRequestDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
     * @summary Get a document from archive with matching queries | Permission required: [\"readOne\", \"ServiceRequest\"]
     * @param {number} serviceRequestId 
     * @param {number} documentStructureId 
     * @param {number} [referrerPersonId] 
     * @param {number} [yearReference] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestDocumentApi
     */
    public getDocumentForServiceId(serviceRequestId: number, documentStructureId: number, referrerPersonId?: number, yearReference?: number, options?: RawAxiosRequestConfig) {
        return ServiceRequestDocumentApiFp(this.configuration).getDocumentForServiceId(serviceRequestId, documentStructureId, referrerPersonId, yearReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary upload a document for a service request
     * @param {number} [serviceRequestId] 
     * @param {number} [documentId] 
     * @param {number} [documentStructureId] 
     * @param {number} [referrerPersonId] 
     * @param {number} [yearReference] 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestDocumentApi
     */
    public uploadDocumentForServiceRequest(serviceRequestId?: number, documentId?: number, documentStructureId?: number, referrerPersonId?: number, yearReference?: number, files?: Array<File>, options?: RawAxiosRequestConfig) {
        return ServiceRequestDocumentApiFp(this.configuration).uploadDocumentForServiceRequest(serviceRequestId, documentId, documentStructureId, referrerPersonId, yearReference, files, options).then((request) => request(this.axios, this.basePath));
    }
}

